/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RateUnitOfMeasure {
    Dollars = 8,
    Flat = 1,
    Miles = 2,
    Percent = 3,
    Units = 4,
    Each = 5,
    FifteenMinutes = 6,
    Pesos = 50,
}
